import { useState, useEffect } from "react";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    const pulseTimer = setInterval(() => setPulse((p) => !p), 2500);
    return () => {
      clearTimeout(timer);
      clearInterval(pulseTimer);
    };
  }, []);

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="Agendar cita por WhatsApp con Dr. Erick Tejada"
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 cursor-pointer ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <div className="relative">
        {pulse && (
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-60" />
        )}
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-colors shadow-lg">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </div>
      </div>
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
